import AddReward from "./AddReward";

export default AddReward;